import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GamepadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"gamepad"}/>
}
